// src/React/src/reducers/agentQueryReducer.ts
import { createReducer, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import * as actions from '../actions/agentQueryActions'
import { ChatMessage, SendMessagePayload, SessionRestoredPayload } from '../actions/agentQueryActions'
import { AgentQueryResponse } from '../api/agentQuery'

export interface AgentQueryStore {
  messages: ChatMessage[]
  isLoading: boolean
  sessionId: string | null
}

const initialState: AgentQueryStore = {
  messages: [],
  isLoading: false,
  sessionId: null,
}

export const agentQuery = createReducer<AgentQueryStore>(initialState, {
  [actions.sendMessage.type]: (state, action: PayloadAction<SendMessagePayload>) => {
    state.isLoading = true
    state.messages.push({
      id: uuidv4(),
      role: 'user',
      text: action.payload.prompt,
      timestamp: Date.now(),
    })
  },
  [actions.messageReceived.type]: (state, action: PayloadAction<AgentQueryResponse>) => {
    state.isLoading = false
    state.sessionId = action.payload.sessionId
    state.messages.push({
      id: uuidv4(),
      role: 'agent',
      text: action.payload.answer,
      timestamp: Date.now(),
    })
  },
  [actions.messageError.type]: (state, action: PayloadAction<string>) => {
    state.isLoading = false
    state.messages.push({
      id: uuidv4(),
      role: 'error',
      text: action.payload,
      timestamp: Date.now(),
    })
  },
  [actions.sessionRestored.type]: (state, action: PayloadAction<SessionRestoredPayload>) => {
    state.sessionId = action.payload.sessionId
    state.messages = action.payload.messages
  },
  [actions.sessionCleared.type]: (state) => {
    state.messages = []
    state.sessionId = null
    state.isLoading = false
  },
})
